/* eslint-disable @typescript-eslint/no-redeclare */
// eslint-disable-next-line no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { MessageDTO } from '../../Types/MessageT';
import { MailS } from '../../Service/MailS';
import { useEventScope } from '../../Service/hooks/useEventScope';

const MessageOwnerInfo: FC<{ message: MessageDTO }> = ({ message }) => {
  const { pathname } = useLocation();
  const { isEventScope } = useEventScope();
  const { box } = useParams();
  // Show only for event view
  if (!isEventScope || pathname.startsWith('postbox') || !['inbox', 'outbound'].includes(box ?? '')) return null;
  const { folderOwner } = message;

  if (folderOwner) {
    return <Text color="dimmed" size={10}>{`${MailS.getFolderLabel(box ?? '')} - ${folderOwner}`}</Text>;
  }
  return <Text color="dimmed" size={10}>{`${MailS.getFolderLabel(box ?? '')} - bookitup`}</Text>;
};

export default MessageOwnerInfo;
